import React, { useRef, useState } from "react";
import QueryService from "services/QueryService";
import { TimePicker } from "@mui/x-date-pickers";

import { default as _last } from "lodash/last";

import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import Grid from "@mui/material/Unstable_Grid2";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import Input from "@mui/material/Input";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import DeleteIcon from "@mui/icons-material/Delete";
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import SaveIcon from "@mui/icons-material/Save";
import moment from "moment-timezone";
import { useEffect } from "react";
const uuidv4 = require("uuid/v4");

const DAYS_OF_WEEK = ["SU", "MO", "TU", "WE", "TH", "FR", "SA"];

const isPositiveInteger = (val) => parseInt(val) === Number(val) && val > 0;

const KNOWN_PERIODS_MAP = {
  /*"5ba24989-5d37-4b1b-8b03-6f6db5686d74":{
    "name":"Select Periods",
    "periods":[]
  },*/
  "32a86f50-8412-4044-af14-2928d12f247d": {
    "guuid": "32a86f50-8412-4044-af14-2928d12f247d",
    "tunits": [{
      "byweekday": [
        "SU",
        "MO",
        "TU",
        "WE",
        "TH",
        "FR",
        "SA"
      ],
      "duration.units": "hours",
      "start": 0.0,
      "duration.value": 24.0,
    }],
    "startofweek": "MO",
    "description": "",
    "label": "24 Hrs:Mon-Sun"
  },
  "50a206b8-d86c-4185-85e2-718e0f070d58": {
    "guuid": "50a206b8-d86c-4185-85e2-718e0f070d58",
    "tunits":
      [
        {
          "byweekday": [
            "MO",
            "TU",
            "WE",
            "TH",
            "FR",
          ],
          "duration.units": "hours",
          "duration.value": 24.0,
          "start": 0.0,
        }],
    "startofweek": "MO",
    "description": "",
    "label": "24 Hrs:Mon-Fri"
  }
}
const Period = (props) => {
  const { period, timezone, update, remove, disabled, userDefinedPeriods, addremUDP  } = props;
  const [dirty, setDirty] = useState(false);
  //console.log("isuserdefined",dirty,period.guuid,Object.keys(userDefinedPeriods), userDefinedPeriods?.[period.guuid], period?.guuid in Object.keys(userDefinedPeriods));
  const updateDays = (idx, event) => {
    const { value: options } = event.target;
    const value = DAYS_OF_WEEK.filter((label) => options.indexOf(label) !== -1);
    updatetunit(idx, "byweekday", value);
    //update({ byweekday: value });
  };
  const updatetunit = (idx, k, v) => {
    period['tunits'][idx][k] = v
    updateme({ 'tnunits': period['tnuits'] });
    
  }
  const updateme = (v) => {
    update(v);
    setDirty(true)
  }
  const savePeriod = () => {
    QueryService.createPeriod(period).then(e => {
    setDirty(false);
    addremUDP(period);
    })
  }
  const deletePeriod = () => {
    QueryService.deletePeriod(period.guuid).then(e => {
      setDirty(true);
      addremUDP(period,true);
    })
  }
  return (
    <div>
      <Grid
        container
        sx={{
          borderRadius: 2,
          borderColor: "lightgray",
          borderWidth: 3,
          borderStyle: "solid",
          padding: 1,
          marginTop: 1,
        }}
      >
        {period?.tunits.map((tunit, idx) =>
          <Grid key={idx} container xs={12} spacing={1} wrap="wrap">
            <Grid xs={12} md={4}>
              <FormControl variant="standard" margin="dense" fullWidth={true}>
                <TimePicker
                  disabled={disabled}
                  key={timezone || "local"}
                  id={`starttime-${period.guuid}-${idx}`}
                  label="Start Time"
                  value={moment.utc(tunit?.start ?? 0).set("second", 0)}
                  onChange={(dt) => {
                    updatetunit(idx, 'start', dt.valueOf());
                  }}
                  error={tunit.start == null}
                  slotProps={{ textField: { variant: "standard" } }}
                />
                {tunit.start == null && (
                  <p style={{ color: "red", fontSize: "10px" }}>
                    Please enter a start time for period/shift
                  </p>
                )}
              </FormControl>
            </Grid>
            <Grid xs={12} md={4}>
              <FormControl variant="standard" margin="dense" fullWidth={true}>
                <TextField
                  variant="standard"
                  disabled={disabled}
                  id={`period-length-value-${period.guuid}`}
                  label="Duration (in hours)"
                  value={tunit["duration.value"] ?? ""}
                  onChange={(event) => {
                    updatetunit(idx, "duration.value", event.target.value);
                  }}
                  /*onChange={(event) => {
                    update({
                      "duration.value": event.target.value,
                    });
                  }}*/
                  type="number"
                  error={tunit["duration.value"] <= 0}
                />
                {tunit["duration.value"] <= 0 && (
                  <p style={{ color: "red", fontSize: "10px" }}>
                    Please enter a duration for period/shift in hours, must be
                    greater than 0 and less than or equal to 24
                  </p>
                )}
              </FormControl>
            </Grid>
            <Grid xs={12} md={4}>
              <FormControl
                variant="standard"
                margin="dense"
                fullWidth={true}
                style={{ marginTop: 8 }}
              >
                <InputLabel error={tunit.byweekday.length === 0}>
                  Days of Week
                </InputLabel>
                <Select
                  variant="standard"
                  disabled={disabled}
                  labelId={`period-days-label-${period.guuid}`}
                  id={`period-days-${period.guuid}`}
                  multiple
                  value={tunit.byweekday ?? []}
                  onChange={(event) => updateDays(idx, event)}
                  input={<Input />}
                  renderValue={(selected) => (
                    <div style={{ fontSize: ".75rem" }}>{selected.join(",")}</div>
                  )}
                  error={tunit.byweekday.length === 0}
                >
                  {DAYS_OF_WEEK.map((label) => (
                    <MenuItem dense key={label} value={label}>
                      {label}
                    </MenuItem>
                  ))}
                </Select>
                {tunit.byweekday.length === 0 && (
                  <p style={{ color: "red", fontSize: "10px" }}>
                    Please select the days of the week period/shift is active
                  </p>
                )}
              </FormControl>
            </Grid>
          </Grid>
        )}
        <Grid container xs={12} spacing={1} wrap="wrap">
          <Grid xs={12} md={4}>
            <FormControl variant="standard" margin="dense" fullWidth={true}>
              <TextField
                variant="standard"
                disabled={disabled}

                id={`period-label-${period.guuid}`}
                label="Label"
                value={period.label}
                onChange={(event) => {
                  updateme({
                    label: event.target.value,
                  });
                }}
                margin="dense"
                error={!period.label}
              />
              {!period.label && (
                <p style={{ color: "red", fontSize: "10px" }}>
                  Please provide a label for period/shift
                </p>
              )}
            </FormControl>
          </Grid>
          <Grid xs={12} md={8}>
            <FormControl variant="standard" margin="dense" fullWidth={true}>
              <TextField
                variant="standard"
                disabled={disabled}
                id={`period-description-${period.guuid}`}
                label="Description (optional)"
                value={period.description}
                onChange={(event) => {
                  updateme({
                    description: event.target.value,
                  });
                }}
                margin="dense"
              />
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Button
                sx={{ textTransform: 'none' }}
                //disabled = {!haveErrors}
                disabled={disabled}
                onClick={userDefinedPeriods?.[period.guuid] && (!dirty) ? deletePeriod : savePeriod}
                size="small"
                variant = "text"
                //startIcon={<SaveIcon />}
              >
                { userDefinedPeriods?.[period.guuid] && (!dirty) ? "- Remove from preconfigured periods" : "+ Add to preconfigured periods" }
              </Button>
              <Button
                onClick={remove}
                size="small"
                variant="contained"
                startIcon={<DeleteIcon />}
              >
                REMOVE FROM REPORT
              </Button>
            </div>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

const PeriodsOption = (props) => {
  const scrollRef = useRef();
  const addingPeriod = useRef(false);

  const { options, setOptions, errors, errorDetected, noErrorDetected, stacks = {}, tagsSelected, } = props;
  const timezone = options.timezone;
  const { periods = [], periods_to_show: periodsToShow = 0, timerange = "day", startofweek = "MO", periodids = [] } = options;
  //const [timerange, setTimerange] = useState(periods.length ? periods[0]?.timerange ?? "day" : "day")
  //const [timerange, setTimerange] = useState(timerange ?? "day")
  const tags = Object.values(tagsSelected ?? {});
  const checkval = options?.ignore_period_match || tags.every((t) => {
    //console.log("every",t.stack,stacks?.[t.stack]?.data_config?.[t.attribute]?.da);
    const da = stacks?.[t.stack]?.data_config?.[t.attribute]?.da
    return (da?.states || da?.counts) ? true : false
  });
  const [userDefinedPeriods, setUserDefinedPeriods] = useState({});
  const [incompatibleMsg, setIncompatibleMsg] = useState("");

  //console.log("checkval",checkval);
  //make old ones forward compatible
  periods.forEach((p) => {
    if (p?.byweekday && p?.["duration.value"] && !p.tunits) {
      p["tunits"] = [{ "duration.units": "hours", "duration.value": p?.["duration.value"], "start": p?.start, "byweekday": p?.byweekday }]
    }
  })
  useEffect(() => {
    if ((!checkval) && periods[0]?.timerange !== "day") {
      console.log("incompatible tags");
      setIncompatibleMsg("Time range options set to Day due to incompatible Tags");
      //initPeriods("day");
      //setTimerange("day");
    }
  });
  const updatePeriod = (guuid) => (update) => {
    const idx = periods.findIndex((p) => p.guuid === guuid);
    if (idx !== -1) {
      const period = periods[idx];
      const newPeriods = [...periods];
      newPeriods[idx] = { ...period, ...update };
      setOptions({
        periods: newPeriods,
      });
    }
  };

  const addremUDP = (period,remflag) => {
    if (period?.guuid) {
      if (remflag) {
        if (period.guuid in userDefinedPeriods) {
          const udp = {...userDefinedPeriods}
          delete udp[period.guuid];
          setUserDefinedPeriods(udp);
        }
      }
      else {
        if(userDefinedPeriods?.[period?.guuid] === undefined){
          const udp = {...userDefinedPeriods}
          udp[period?.guuid] = period
          setUserDefinedPeriods(udp);
        }
        else {
          console.log("already in UDP",Object.keys(userDefinedPeriods),period?.guuid)
        }
      }
    }
  }

  useEffect(() => {
    QueryService.getPeriods().then(e => {
      setUserDefinedPeriods(e);
    });
  }, []);

  // check all periods for validity, and signal error if at least one incorrectly configured
  useEffect(() => {
    let haveErrors = false;
    periods.forEach((period) => {
      // each period should have valid start, byweekday and label
      period?.tunits.forEach((tunit) => {
        const { start, "duration.value": duration, byweekday } = tunit;
        if (start == null || !duration || byweekday.length === 0 || !period?.label) {
          haveErrors = true;
        }
      })
    });
    if (haveErrors && !errors.periods) {
      errorDetected("periods");
    } else if (!haveErrors && errors.periods) {
      noErrorDetected("periods");
    }
  }, [errorDetected, noErrorDetected, periods, errors.periods]);

  useEffect(() => {
    if (addingPeriod.current) {
      if (scrollRef.current) {
        scrollRef.current.scrollIntoView({ behaviour: "smooth" });
      }
      addingPeriod.current = false;
    }
  }, [periods]);

  const createPeriod = () => {
    const newPeriod = {
      guuid: uuidv4(),
      "tunits": [
        {
          start: 0,
          "duration.units": "hours",
          "duration.value": 24,
          byweekday: DAYS_OF_WEEK,
        }
      ],
      label: timerange,
      description: "",
      startofweek: "MO"
      /*"duration.value": timerange !== "day" ? 24 : 0,
      byweekday: timerange !== "day" ? DAYS_OF_WEEK : [],
      label: timerange !== "day" ? timerange : "",*/
      //timerange: timerange,
    };
    setOptions({
      periods: [...periods, newPeriod],
      periodids: [...periodids, newPeriod.guuid]
    });
    addingPeriod.current = true;
    // scrollRef.current.scrollIntoView({ behaviour: "smooth" });
  };

  const removePeriod = (guuid) => () => {
    setOptions({
      periods: periods.filter((p) => p.guuid !== guuid),
      periodids: periodids.filter((p) => p !== guuid),
    });
  };
  const updateTimeRange = (event) => {
    //console.log("in updateTimerange",timerange,event);
    const newval = event.target.value;
    //initPeriods(newval);
    //setTimerange(newval);
    setOptions({ 'timerange': newval })
  }

  const updateStartofWeek = (event) => {
    //console.log("in updateTimerange",timerange,event);
    const newval = event.target.value;
    //initPeriods(newval);
    //setTimerange(newval);
    setOptions({ 'startofweek': newval })
  }

  const setKnownPeriods = (event, idx = 0) => {
    //console.log("in updateTimerange",timerange,event);
    const newval = event.target.value;
    let newPeriod = null;
    //console.log("known period is",idx,newval,KNOWN_PERIODS_MAP?.[newval]);
    if (newval === "new-period") {
      createPeriod()
    }
    else if (KNOWN_PERIODS_MAP?.[newval]) {
      newPeriod = JSON.parse(JSON.stringify(KNOWN_PERIODS_MAP?.[newval]))
      //setOptions({periodids: [newval],periods: ([KNOWN_PERIODS_MAP?.[newval]] ?? [])})
    }
    else if (userDefinedPeriods?.[newval]) {
      newPeriod = JSON.parse(JSON.stringify(userDefinedPeriods?.[newval]))
      //setOptions({periodids: [newval],periods: ([userDefinedPeriods?.[newval]] ?? [])})
    }
    else {
      console.log("Unknown Period selected")
    }
    if (newPeriod) {
      if (periods.length <= idx) { //append to periods
        setOptions({ periods: [...periods, newPeriod], periodids: [...periodids, newPeriod.guuid] })
      }
      else {
        //const period = periods[idx];
        const newPeriods = [...periods];
        newPeriods[idx] = newPeriod;
        const newPeriodids = newPeriods.map((p) => p.guuid)
        setOptions({
          periods: newPeriods,
          periodids: newPeriodids,
        });
      }
    }
  }
  const initPeriods = (tm) => {//clear all periods any time time range changes? better eh?
    const newPeriod = {
      guuid: uuidv4(),
      "duration.units": "hours",
      "duration.value": tm !== "day" ? 24 : 0,
      byweekday: tm !== "day" ? DAYS_OF_WEEK : [],
      label: tm !== "day" ? tm : "",
      description: "",
      timerange: tm,
      start: 0,
      startofweek: "MO"
    }
    setOptions({ periods: [newPeriod] })
  }

  //when timerange changes, clean up periods and create new ones
  /*useEffect(() => {
    console.log("in useEffect");
    clearPeriods();
  },[timerange]);*/

  return (
    <FormControl
      variant="standard"
      margin="dense"
      sx={{ width: "calc(100% - 48px)", margin: 3 }}
    >
      <FormLabel component="legend">Data Aggregation</FormLabel>
      {incompatibleMsg.length > 0 && (
        <p style={{ color: "purple", fontSize: "11px" }}>
          {incompatibleMsg}
        </p>
      )}
      <Grid item container spacing={1} xs={12}>
        <Grid item xs={6}>
          <FormControl
            variant="standard"
            margin="dense"
            fullWidth={true}
            style={{ marginTop: 11 }}>
            <InputLabel >
              Unit of Aggregation per period
            </InputLabel>
            <Select
              variant="standard"
              labelId={`period-range-selection`}
              id={`period-range-select`}
              value={timerange}
              onChange={updateTimeRange}
              input={<Input />}
            /*renderValue={(selected) => (
              <div style={{ fontSize: ".75rem" }}>{selected.join(",")}</div>
            )}*/
            >
              {(checkval ? ['shift', 'day', 'week', 'month'] : ['shift', 'day']).map((label) => (
                <MenuItem dense key={label} value={label}>
                  {label[0].toUpperCase() + label.slice(1)}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={6}>
          {timerange === "week" &&
            <FormControl margin="dense"
              variant="standard"
              fullWidth={true}
              style={{ marginTop: 11 }}>
              <InputLabel >
                Start of Week
              </InputLabel>
              <Select
                variant="standard"
                labelId={`period-range-selection`}
                id={`period-range-select`}
                value={startofweek}
                onChange={updateStartofWeek}
                input={<Input />}
                /*renderValue={(selected) => (
                  <div style={{ fontSize: ".75rem" }}>{selected.join(",")}</div>
                )}*/>
                {(['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']).map((label) => (
                  <MenuItem dense key={label} value={label[0] + label[1].toUpperCase()}>
                    {label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          }
        </Grid>
      </Grid>
      {!(options?.hide_num_periods ?? false) && (
        <Grid item xs={12} md={6}>
          <FormControl variant="standard" margin="dense" fullWidth={true}>
            <TextField
              id="periods-count"
              label="# periods"
              variant="standard"
              value={periodsToShow ?? ""}
              onChange={(event) => {
                setOptions({
                  periods_to_show: event.target.value,
                });
                if (!isPositiveInteger(event.target.value)) {
                  errorDetected("periodsToShow");
                } else {
                  noErrorDetected("periodsToShow");
                }
              }}
              type="number"
              error={!isPositiveInteger(periodsToShow)}
            />
            {!isPositiveInteger(periodsToShow) && (
              <p style={{ color: "red", fontSize: "10px" }}>
                Please enter a positive value for # periods to show
              </p>
            )}
          </FormControl>
        </Grid>
      )}
      {
        //( timerange === "day" && <div>
        (true && <div>
          <Typography
            variant="overline"
            style={{ marginRight: 6 }}
          >{`Configure or select a period`}</Typography>
          <Select
            variant="standard"
            labelId={`known-periods-selection`}
            id={`known-periods-select-0`}
            value={periodids.length ? periodids[0] : "5ba24989-5d37-4b1b-8b03-6f6db5686d74"}
            onChange={(event) => setKnownPeriods(event, 0)}
            input={<Input />}
            /*renderValue={(selected) => (
              <div style={{ fontSize: ".75rem" }}>{selected.join(",")}</div>
            )}*/>
            {<MenuItem dense key="new-period" value="new-period" disabled={periods.length} >
              Custom
            </MenuItem>}
            {(Object.keys(KNOWN_PERIODS_MAP)
            ).map((pid) => (
              <MenuItem dense key={pid} value={pid}>
                {KNOWN_PERIODS_MAP[pid]?.label ?? "Unnamed"}
              </MenuItem>
            ))}
            {(Object.keys(userDefinedPeriods)
            ).map((pid) => (
              <MenuItem dense key={pid} value={pid}>
                {userDefinedPeriods[pid]?.label ?? "Unnamed"}
              </MenuItem>
            ))}
          </Select>
        </div>
        )}
      <Grid container>
        {periods.length > 0 ? (
          <>
            {periods.map((period, idx) => (
              <>
                <div
                  key={period.guuid}
                  ref={period === _last(periods) ? scrollRef : null}
                >
                  <Period
                    period={period}
                    timezone={timezone}
                    update={updatePeriod(period.guuid)}
                    remove={removePeriod(period.guuid)}
                    addremUDP={addremUDP}
                    userDefinedPeriods = {userDefinedPeriods}
                    disabled={period.guuid in KNOWN_PERIODS_MAP}
                  />
                </div>
                {timerange === "shift" && (
                  <div>
                    <Typography
                      variant="overline"
                      style={{ marginRight: 6 }}
                    >{`Configure or select a period`}</Typography>
                    <Select
                      variant="standard"
                      labelId={`known-periods-selection`}
                      id={`known-periods-select-${idx + 1}`}
                      value={periodids.length > idx + 1 ? periodids[idx + 1] : "5ba24989-5d37-4b1b-8b03-6f6db5686d74"}
                      onChange={(event) => setKnownPeriods(event, idx + 1)}
                      input={<Input />}
                      /*renderValue={(selected) => (
                        <div style={{ fontSize: ".75rem" }}>{selected.join(",")}</div>
                      )}*/>
                      {<MenuItem dense key="new-period" value="new-period" disabled={periods.length !== idx + 1} >
                        Custom
                      </MenuItem>}
                      {(Object.keys(KNOWN_PERIODS_MAP)
                      ).map((pid) => (
                        <MenuItem dense key={pid} value={pid}>
                          {KNOWN_PERIODS_MAP[pid]?.label ?? "Unnamed"}
                        </MenuItem>
                      ))}
                      {(Object.keys(userDefinedPeriods)
                      ).map((pid) => (
                        <MenuItem dense key={pid} value={pid}>
                          {userDefinedPeriods[pid]?.label ?? "Unnamed"}
                        </MenuItem>
                      ))}
                    </Select>
                  </div>)
                }
              </>
            ))}
          </>
        ) : (
          <div></div>
        )}
      </Grid>
    </FormControl>
  );
};

export default PeriodsOption;
